import { Conditional } from 'components/pcc-components';
import TooltipDisclaimer from '../tooltip-disclaimer/tooltip-disclaimer';
import { getAvailabilityTitle } from '../utils';
import { useTranslations } from 'next-intl';
import { AvailabilityTitleType } from './types';

const AvailabilityTitle = ({
  hideLabel,
  availabilityToolTipMessage,
  isDeliveryEnabled,
  isPickupEnabled,
  hideToolTipIcon = true
}: AvailabilityTitleType) => {
  const t = useTranslations();
  return (
    <Conditional test={!hideLabel}>
      <div
        data-testid="availability-title"
        className="d-flex align-items-center justify-content-start mb-2"
      >
        <h2 className="cat-u-theme-typography-label m-0 text-start text-capitalize">
          {t(getAvailabilityTitle(isDeliveryEnabled, isPickupEnabled))}
        </h2>
        <Conditional test={hideToolTipIcon}>
          <TooltipDisclaimer
            availabilityToolTipMessage={availabilityToolTipMessage}
          />
        </Conditional>
      </div>
    </Conditional>
  );
};

export default AvailabilityTitle;
